import { Controller } from '@hotwired/stimulus'

export default class PopoverController extends Controller {
  static targets = ['container', 'content', 'title'];

  static values = {
    initialized: Boolean
  }

  connect() {
    this.initializedValue = false;
    this.isVisible = false
  }

  toggle() {
    if (this.isVisible) {
      this.close();
    } else {
      if (this.hasContentTarget) this.contentTarget.classList.remove('d-none');
      if (this.hasTitleTarget) this.titleTarget.classList.remove('d-none');

      requestAnimationFrame(() => this.showPopover());
    }
  }

  showPopover() {
    if (!this.initializedValue) {
      this.popover = new bootstrap.Popover(this.containerTarget, {
        html: true,
        placement: 'bottom',
        title: this.titleTarget,
        content: this.contentTarget,
        container: this.element,
        trigger: 'manual',
        fallbackPlacements: [],
        offset: ({ placement, reference, popper }) => {
          if (placement === 'bottom') {
            if(window.innerWidth < 577) {
              return [0, 12];
            } else {
              if(reference.width > 120) {
                return [-reference.width + 66, 12];
              } else {
                return [-reference.width + 36, 12];
              }
            }
          } else {
            return [];
          }
        },
      });
      this.initializedValue = true;
    }

    this.popover.show();
    this.isVisible = true;

    requestAnimationFrame(() => {
      if (this.popover._popper) {
        this.popover._popper.update();
      }
    });
  }

  close() {
    if (this.popover) {
      this.popover.hide();
    }
    this.isVisible = false;
  }
}
